import React from 'react';

const MembersIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.66699 15.8333C1.66699 14 3.16699 12.5 5.00033 12.5H8.33366C10.167 12.5 11.667 14 11.667 15.8333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.75022 5.00029C9.91689 6.16696 9.91689 8.00029 8.75022 9.08362C7.58356 10.167 5.75022 10.2503 4.66689 9.08362C3.58356 7.91696 3.50022 6.16696 4.58356 5.00029C5.66689 3.83362 7.58356 3.91696 8.75022 5.00029"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.334 11.668H15.834C17.2507 11.668 18.334 12.7513 18.334 14.168"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0841 5.58594C16.9174 6.41927 16.9174 7.7526 16.0841 8.5026C15.2507 9.25261 13.9174 9.33594 13.1674 8.5026C12.4174 7.66927 12.3341 6.33594 13.1674 5.58594C13.9174 4.83594 15.2507 4.83594 16.0841 5.58594"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MembersIcon;
